module.exports = require("markdown-it-highlightjs");